export const RESET_SESSION_TIMEOUT_EVENT_NAME = "resetSessionTimeoutEvent";